import { render } from "./WarnModal.vue?vue&type=template&id=984d05da&scoped=true"
import script from "./WarnModal.vue?vue&type=script&lang=js"
export * from "./WarnModal.vue?vue&type=script&lang=js"

import "./WarnModal.vue?vue&type=style&index=0&id=984d05da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-984d05da"]])

export default __exports__